import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, OnDestroy, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { take } from 'rxjs';
import { JsonDataService } from '../../../../services/json-data/json-data.service';
import { SignialsService } from '../../../../services/signals/signials.service';
import { GameOverlayService } from '../../../../services/game-overlay/game-overlay.service';
import { CloseButtonService } from '../../../../services/close-button.service';
import { GameUiService } from '../../../../services/game-ui/game-ui.service';
import { GameContext } from '../../../../services/game-ui/game-context.enum';
import { CardSection, CardSectionType } from '../../../ui/base/result-card/result-card.component';
import { SPINE_KEYS } from '../../../../constants/textures';
import { AssetExtService } from '../../../../services/asset-ext.service';

export interface FreidResult {
	shortResume: string;
	name: string;
	resume: string;
	descriptionData: {
		main: string;
		weakness: string;
		advice: string[];
	}
}
@Component({
  selector: 'app-freid',
	providers: [
		JsonDataService,
	],
  templateUrl: './freid.component.html',
  styleUrl: './freid.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None
})
export class FreidComponent implements OnInit, OnDestroy {
	@Output()
	finishGame: EventEmitter<any[]> = new EventEmitter();
	@Output()
	closeModal: EventEmitter<void> = new EventEmitter();
	@Output()
	showPhrase: EventEmitter<string> = new EventEmitter();

	showMiniGame = true;
	showGame = false;

	questions;

	showResult = false;
	subs;
	result = '';
	color = '#36776C';

	resultImg = './assets-compressed/categories/freid/result/';
	resultInfo: FreidResult;
	resultData: CardSection[];

	personalityTypes: string[] = [
		'ENFJ', 'ENFP', 'ENTJ', 'ENTP',
		'ESFJ', 'ESFP', 'ESTJ', 'ESTP',
		'INFJ', 'INFP', 'INTJ', 'INTP',
		'ISFJ', 'ISFP', 'ISTJ', 'ISTP',
	];
	title = '';
	constructor(
		private signal: SignialsService,
		private cdr: ChangeDetectorRef,
		private jsonData: JsonDataService,
		private overlay: GameOverlayService,
		private btnService: CloseButtonService,
		private ui: GameUiService,
		private assetExt: AssetExtService
	) {}

	ngOnInit(): void {
		const gender = localStorage.getItem('gender');
		this.resultImg += gender === 'male' ? 'man' : 'woman';
		this.subs = this.btnService.btnClicked$.subscribe(() => {
			if (this.showMiniGame) this.closedMiniGame();
			else if (!this.signal.dialogActive$.value) this.closeModal.emit();
		});

		this.jsonData.loadJson('freid/questions').subscribe(data => {
			this.questions = data;
		});
		this.shuffle(this.personalityTypes);
	}

	ngOnDestroy(): void {
		this.closed();
		this.subs.unsubscribe();
	}

	hideMiniGame() {
		this.showMiniGame = false;
		this.showContinue();
		this.cdr.detectChanges();
	}
	shuffle(arr) {
		arr.sort(() => Math.random() - 0.5);
	}


	closedMiniGame() {
		this.showMiniGame = false;
		this.showContinue();
			// console.log('DIALOG ENDED')
		this.cdr.detectChanges();
	}

	showContinue() {
		this.showPhrase.emit('continue');
		// TO DO отписаться если take не будет вызван
		this.signal.dialogEnded.pipe(take(1)).subscribe(() => {
			this.showGame = true;
			this.ui.setContext(GameContext.GameProfessor);
			this.cdr.detectChanges();
		});
	}

	closedModal() {
		this.showGame = false;
		this.showPhrase.emit('finish');
		// TO DO отписаться если take не будет вызван
		this.signal.dialogEnded.pipe(take(1)).subscribe(() => {
			this.closeModal.emit(); 
		});
	}
	closed() {
		this.finishGame.emit([SPINE_KEYS.freid, {title: this.resultInfo.name, resume: this.resultInfo.shortResume}]);
	}
	changeResult(type: string) {
		this.result += type;
		if (this.result.length === 4) {
			this.jsonData.loadJson<FreidResult>(`freid/results/${this.result}`).subscribe(result => {
				this.title = result.name;
				this.resultInfo = result;
				this.resultData = [
					{
						text: [result.descriptionData.main],
						type: CardSectionType.Simple,
					},
					{
						text: ['mb-1'],
						type: CardSectionType.Space
					},
					{
						text: ['Зоны роста'],
						type: CardSectionType.Subtitle,
					},
					{
						text: ['mb-1 sm:mb-1'],
						type: CardSectionType.Space
					},
					{
						text: [result.descriptionData.weakness],
						type: CardSectionType.Simple,
					},
					{
						text: ['mb-1'],
						type: CardSectionType.Space
					},
					{
						text: ['Рекомендации'],
						type: CardSectionType.Title2,
					},
					{
						text: ['mb-1 sm:mb-1'],
						type: CardSectionType.Space
					},
					{
						text: result.descriptionData.advice,
						type: CardSectionType.List,
					}
				];
				const img = this.assetExt.getBackgroundImageUrlSync(this.result + '.png');
				this.resultImg += '/' + img;
				this.overlay.hideSpeaker();
				this.showResult = true;
				this.cdr.detectChanges();
			});
		}
	}
}
